// Centralized detection class configuration
// Used across LandingPage, DetectionResultCard, and export utilities

export const CLASS_COLORS: Record<string, string> = {
  dense_sphere: '#3b82f6',       // Blue
  hollow_sphere: '#22c55e',      // Green
  'non_sphere-broken': '#f97316', // Orange
  polymer: '#ef4444',            // Red
};

export const CLASS_BADGE_VARIANTS: Record<string, 'default' | 'secondary' | 'destructive' | 'outline'> = {
  dense_sphere: 'default',
  hollow_sphere: 'secondary',
  'non_sphere-broken': 'outline',
  polymer: 'destructive',
};

// Display names for UI (formatted versions of class names)
export const CLASS_DISPLAY_NAMES: Record<string, string> = {
  dense_sphere: 'Dense Sphere',
  hollow_sphere: 'Hollow Sphere',
  'non_sphere-broken': 'Broken/Non-Spherical',
  polymer: 'Polymer/Gunk',
};

// Helper function to format class name for display
export const formatClassName = (className: string): string => {
  return CLASS_DISPLAY_NAMES[className] || className.replace(/_/g, ' ');
};
